import { styled, Currency, LazyImage, CustomLink, Body, Tag, Caption } from '@teko/ds-desktop';
import React, { useState } from 'react';
import { t } from '../../i18n.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCurrency = styled(Currency)`
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
`;
const StyledTextCurrency = styled.span`
  width: max-content;
  display: inline-block;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
`;
const Wrapper = styled.div`
  display: flex;
`;
const Right = styled.div`
  flex: 1;
  margin-left: 1rem;
`;
const StyledCurrencyQuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ListedPrice = styled(Currency)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme == null ? void 0 : theme.colors.textSecondary};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const DiscountWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const StrikeThroughPrice = styled.div(({ theme }) => {
  return `
  text-decoration: line-through;
  color: ${theme == null ? void 0 : theme.colors.textSecondary};
  font-size: 0.75rem;
`;
});
const ItemNote = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: ${({ expanded, line }) => expanded ? "unset" : line};
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
  max-height: ${({ expanded, maxHeight }) => expanded ? "fit-content" : maxHeight};
  width: 100%;
  line-height: 1.5em;
  white-space: normal;
  font-style: italic;
  color: ${({ theme }) => theme == null ? void 0 : theme.colors.neutral};
  word-break: break-word;
  overflow-wrap: break-word;
  padding-right: 0;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
`;
const StyledLi = styled.li`
  list-style-type: disc;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  margin-left: 1.5rem;
  color: ${({ theme }) => theme == null ? void 0 : theme.colors.textSecondary};
`;
const IMAGE_LIMIT = 4;
const ComboImageWrapper = styled.div`
  width: 78px;
  height: 78px;
  background: #f8f8fc;
  border-radius: 4px;
  position: relative;
`;
const ComboChildImage = styled(LazyImage)`
  border-radius: 4px;
  width: 34px;
  height: 34px;
  margin: 4px 0 0 4px;
`;
const ComboRemainingNumber = styled.div`
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  background: rgba(27, 29, 41, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  right: 4px;
  bottom: 4px;
`;
const renderComboImages = (images) => {
  const remaining = images.length - IMAGE_LIMIT;
  return /* @__PURE__ */ React.createElement(ComboImageWrapper, null, images.slice(0, IMAGE_LIMIT).map((src, index) => /* @__PURE__ */ React.createElement(ComboChildImage, {
    key: index,
    src,
    height: 33,
    width: 33,
    contain: true,
    alt: "product"
  })), remaining > 0 && /* @__PURE__ */ React.createElement(ComboRemainingNumber, null, "+", remaining + 1));
};
const ProductCheckoutInfo = (_a) => {
  var _b = _a, {
    imageUrl,
    name,
    quantity,
    price,
    unitPrice,
    gifts,
    targetPath,
    consultationServiceFee = 0,
    comboImages = [],
    tags,
    displayPrice,
    sku,
    attributeDescription,
    strikeThroughDisplayPrice,
    formatNumber,
    note,
    displayTotalAvailable
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "name",
    "quantity",
    "price",
    "unitPrice",
    "gifts",
    "targetPath",
    "consultationServiceFee",
    "comboImages",
    "tags",
    "displayPrice",
    "sku",
    "attributeDescription",
    "strikeThroughDisplayPrice",
    "formatNumber",
    "note",
    "displayTotalAvailable"
  ]);
  const [expanded, setExpanded] = useState(false);
  const renderNote = (note2) => {
    if (!note2)
      return null;
    return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(ItemNote, {
      maxHeight: "4.5em",
      expanded,
      line: 3,
      onClick: () => setExpanded(!expanded)
    }, t("Ghi ch\xFA"), ": ", note2));
  };
  const renderGifts = (gifts2) => {
    if (!gifts2 || gifts2.length === 0)
      return null;
    return /* @__PURE__ */ React.createElement(Wrapper, {
      style: { flexDirection: "column", marginTop: "0.5rem" }
    }, /* @__PURE__ */ React.createElement(Caption, {
      level: 3,
      textTransform: "uppercase"
    }, t("Khuy\u1EBFn m\xE3i \xE1p d\u1EE5ng")), /* @__PURE__ */ React.createElement("ul", null, gifts2.map((gift, index) => /* @__PURE__ */ React.createElement(StyledLi, {
      key: index
    }, gift.name))));
  };
  return /* @__PURE__ */ React.createElement("div", __spreadValues({}, props), /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("div", null, comboImages.length > 0 ? renderComboImages(comboImages) : /* @__PURE__ */ React.createElement(LazyImage, {
    height: 78,
    width: 78,
    borderRadius: 4,
    contain: true,
    border: true,
    src: imageUrl,
    alt: "product"
  })), /* @__PURE__ */ React.createElement(Right, null, !!targetPath ? /* @__PURE__ */ React.createElement(CustomLink, {
    href: targetPath,
    target: "_blank",
    passHref: true
  }, /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: "textPrimary",
    weight: "regular",
    line: 1,
    hoverColor: "primary500"
  }, !!tags && tags.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
    type: "secondary",
    variant: "branding",
    content: tags[0]
  }), "\xA0"), name)) : /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: "textPrimary",
    weight: "regular",
    line: 1,
    hoverColor: "primary500"
  }, !!tags && tags.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
    type: "secondary",
    variant: "branding",
    content: tags[0]
  }), "\xA0"), name), !!displayTotalAvailable && /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "#E6983A"
  }, displayTotalAvailable), !!attributeDescription && /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "textSecondary"
  }, attributeDescription), !!sku ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledCurrencyQuantityWrapper, null, /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: price,
    formattedValue: formatNumber ? formatNumber(price) : void 0
  }), /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: "#82869E"
  }, "x", quantity)), unitPrice && unitPrice !== price - consultationServiceFee && /* @__PURE__ */ React.createElement(DiscountWrapper, null, /* @__PURE__ */ React.createElement(ListedPrice, {
    horizontal: false,
    size: "md",
    value: unitPrice,
    formattedValue: formatNumber ? formatNumber(unitPrice) : void 0,
    lineThrough: true
  })), strikeThroughDisplayPrice && /* @__PURE__ */ React.createElement(DiscountWrapper, null, /* @__PURE__ */ React.createElement(StrikeThroughPrice, null, strikeThroughDisplayPrice))) : /* @__PURE__ */ React.createElement(StyledTextCurrency, null, displayPrice), renderNote(note))), renderGifts(gifts));
};

export { ProductCheckoutInfo };
